import qs from 'qs';
import { client } from './client';
import interceptors from '@/api/interceptors';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function login(username, password) {
	return client.post('/tunnel/api/public/login', qs.stringify({ type: 'stockist', username, password }), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function loginOtp(username, otp_code) {
	return client.post('/tunnel/api/public/login/otp', qs.stringify({ type: 'stockist', username, otp_code }), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function loginSSO(params) {
	return client.post('/tunnel/api/public/login/ssoStockist', qs.stringify(params), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function getTokenSso() {
	return client.get("tunnel/api/stockist/sso/sso-link");
}

export {
	login,
	loginOtp,
	loginSSO,
	getTokenSso
};